import React,{ useEffect, useState } from 'react';
import { Typography, Grid, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
//import { useSelector } from "react-redux";
import {storeLandingMenuItemsReducer} from "../ReduxStore/Actions/actions";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../pages/Loader/Loading";

export default function Home({ firstName, lastName }) {
    //const [data, setData] = useState([]);

    const landingMenuItems =
    useSelector((state) => state.storeLandingMenuItemsReducer.menuItems) || [];
    let landingMenuesNotChanged1;
    //console.log(sessionStorage.getItem('eperformanceLandingMenuItems'));
    if(sessionStorage.getItem('eperformanceLandingMenuItems')==null){
    sessionStorage.setItem('eperformanceLandingMenuItems',JSON.stringify(landingMenuItems));
   
    }
    const eperformanceLandingMenuItems  = sessionStorage.getItem('eperformanceLandingMenuItems');
    landingMenuesNotChanged1 = JSON.parse(eperformanceLandingMenuItems);

    useEffect(() => {

       
      //console.log('landingMenuesNotChanged1',landingMenuesNotChanged1)
     
    }, []);

    return (
        // <p>hi</p>
        <>
        {
        landingMenuesNotChanged1?.length ? 
        (<Grid container spacing={1} className="position-relative">
             {landingMenuesNotChanged1.map((item, index) => (
            <Grid item xs={12} sm={6} className="home-user-description" key={index}>
                 <Link to={item.menuLink} >
                <div className="description-block">
                    <div className="d-flex">
                        <div className="description-bdr"></div>
                        <h1 className="mt-0 get-MyId-username clr-white"> Hello, {firstName} {lastName}</h1>
                    </div>
                    <Typography className="clr-white project-desc">
                        Welcome to E-Performance
                    </Typography>
                    <Button variant="contained" className="homepage-master-btn ns-btn-hero">
                        <span className="f-20 fw-bold">{item.menuName}</span>
                    </Button>
                </div>
                </Link>
            </Grid>
          ))}

            <Grid item xs={12} sm={6} className="cognisphere-vid-block" id="CognisphereVid">
                <video autoPlay loop muted className="width-100 height-100">
                    <source src={"../assets/animation/cognisphere_home.mp4"} type="video/mp4" />
                </video>
            </Grid>
        </Grid>): <></>
        }
    :
      </>
    )
  }
